import { useState } from "react";
import { ButtonPrimary } from "../../../components/NewButtons";
import { MutateProductTagDrawer } from "./MutateProductTagDrawer";

export const CreateProductTagSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <ButtonPrimary
        onClick={() => {
          setIsOpen(true);
        }}
      >
        Create product tag{" "}
      </ButtonPrimary>
      <MutateProductTagDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </div>
  );
};
